var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{class:_vm.$style.errorPage},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',{staticClass:"text-4xl leading-7xl"},[_vm._v("Dead end! Sorry about that."),_c('br'),_vm._v("Please head back to our homepage"),_c('br'),_vm._v("or log in to find what you need.")])
}]

export { render, staticRenderFns }